export default __webpack_public_path__ + "static/media/XSale_nowe_logo_czarny.c9d07cf3.png";